import { SK_tempUserSession } from '../data/config';
import { parseJson, stringifyJSON } from './helperFunction/jsonHandler';

//set temporal session
export const setTemporalSession = (value: Record<string, string | boolean>) => {
  if (!value) return;
  const stringValue = stringifyJSON(value);
  sessionStorage.setItem(SK_tempUserSession, stringValue);
};

//get temporal session
export const getTemporalSession = () => {
  const value = sessionStorage.getItem(SK_tempUserSession);
  if (value) return parseJson(value);
  else return;
};

//get temporal session
export const updateTemporalSession = (update: Record<string, boolean>) => {
  const value = getTemporalSession();
  if (value) {
    if (typeof value !== 'object') return;
    const newValue = { ...value, ...update };
    setTemporalSession(newValue);
  } else return;
};

//clear temporal session
export const clearTemporalSession = () =>
  sessionStorage.removeItem(SK_tempUserSession);
